<script>
import { mapState, mapActions } from 'vuex';
import getIndividualStatistic from 'api/getIndividualStatistic';

export default {
  name: 'answer-templates',
  async mounted() {
    await this.loadAnswerTemplates();
    this.statistics = await getIndividualStatistic();
  },
  data() {
    return {
      statistics: [],
    };
  },
  methods: {
    ...mapActions('operatorChat', ['loadAnswerTemplates']),
    close() {
      this.$parent.close([null]);
    },
  },
  computed: {
    ...mapState('operatorChat', ['answerTemplates']),
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  header(:class="$style.header")
    div(:class="$style.headerTitle", data-test="STATISTICS") {{ $t('T_STATISTICS') }}
  div(:class="$style.content")
    div(v-for="(statistic,index) in statistics",  :class="[$style.statistic]")
      div(:class="[$style.statisticLabel, statistic[2] && $style.help]", :title="$t(statistic[2] ? statistic[2] : '')",
        data-test="OPERATOR_INDIVIDUAL_STATISTICS") {{ $t(statistic[0]) }}
      div(:class="$style.statisticCount") {{ statistic[1] }}
</template>

<style lang="sass">
.menu__content
  z-index: 10009

</style>

<style lang="sass" module>
.root
  display: block
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
  &Title
    font-size: 18px
    display: flex
    justify-content: center
.content
  display: flex
  flex-direction: column
  padding: 24px
  min-width: 532px
  height: 303px
  flex: 1 1 100%
.action
  display: flex
  padding: 24px
  justify-content: space-around
.statistic
  display: flex
  align-items: stretch
  line-height: 18px
  transition: color $a_speed
  & + &
    margin-top: 16px
  &Label
    width: 50%
    overflow: hidden
    text-overflow: ellipsis
    font-size: 16px
    margin-right: 24px
    vertical-align: baseline
    &.help
      cursor: help
  &Count
    margin-left: 8px
    font-size: 16px
    font-weight: bold
    vertical-align: baseline
    white-space: nowrap
    display: flex
    justify-content: center
    flex-grow: 1

</style>
